@if (collectionStatus !== 'loading') {
  <table
    mat-table
    [dataSource]="collectionList"
    matSort
    (matSortChange)="onMatSortChange()"
    >
    <ng-container matColumnDef="collectionName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Collection Name
        <span class="sort-icon sort-up"></span>
        <span class="sort-icon sort-down"></span>
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        >
        @if (checkCanRename(element.featureUUID)) {
          <div class="name-info-block">
            @if (element.featureName.length < 20) {
              <span class="collectionName" [innerHTML]="element.featureName"></span>
            } @else {
              <span class="collectionName" matTooltip="{{element.featureName}}" matTooltipPosition="above" [innerHTML]=" element.featureName.substr(0,17)+'...'"></span>
            }
          </div>
        } @else {
          <form [formGroup]="updateCollectionForm" class="name-edit-block">
            <label>
              <input
                type="text"
                [(ngModel)]="name"
                formControlName="name"
                class="edit-name-input"
                [value]="element.featureName"
                />
              </label>
              @if (!updateCollectionForm.valid) {
                <p class="error-msg">{{ getValidationError() }}</p>
              }
            </form>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="reportType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Report Type
          <span class="sort-icon sort-up"></span>
          <span class="sort-icon sort-down"></span>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          >
          <span
            class="collection-name"
            [ngClass]="element.featureType === 'Single Data Point' ? 'single-data-points' : (element.featureType === 'Multi Data Points' ? 'multi-data-points' : 'two-data-points') "
          [innerHTML]="element.featureType"></span>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          @if (checkCanRename(element.featureUUID)) {
            <div class="image-actions">
              <button
                class="action edit"
                matTooltipClass="matTooltip"
                matTooltip="Rename"
                matTooltipPosition="above"
                [ngClass]="setActiveStyles('edit', element.id)"
                [disabled]="!canRename"
                (click)="editName(element.featureUUID, element.featureName, $event)"
              ></button>
              <button
                class="action remove"
                matTooltipClass="matTooltip"
                matTooltip="Delete"
                matTooltipPosition="above"
                [ngClass]="setActiveStyles('remove', element.featureUUID)"
                [disabled]="!canRename"
                (click)="deleteCollection(element)"
              ></button>
            </div>
          } @else {
            <div class="primary">
              <button
                class="cancel-btn"
              (click)="cancel($event)">Cancel</button>
              <button
                class="save-btn"
                [ngClass]="updateCollectionForm.valid && (updateCollectionForm.controls['name'].dirty || updateCollectionForm.controls['name'].touched)  ? 'save-btn-enabled' : 'save-btn-disabled'"
              (click)="save($event, element)">Save</button>
            </div>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; let element; columns: displayedColumns"
        (click)="selectCollection(element.featureUUID)"
        [ngStyle]="{ cursor: 'pointer' }"
        [attr.data-name]="element.featureName.length > 20 ? element.featureName.substr(0,17)+'...' : element.featureName"
        [attr.data-id]="element.featureUUID"
      ></tr>
      <tr class="mat-row" *matNoDataRow class="removeHover" >
        <td class="mat-cell no-border" colspan="3">
          @if (searchCollection.length > 0) {
            <div class="empty-message">Collection with the name "{{searchCollection}}" cannot be found.</div>
          }
          @if (searchCollection.length === 0) {
            <div class="empty-message">You have no collections. Create a collection.</div>
          }
        </td>
      </tr>
    </table>
  } @else {
    <loading-icon></loading-icon>
  }



  <saving-in-progress [showSavingInProgress]="savingInProgress"></saving-in-progress>

  <app-clickatell-toasts [type]="toastType" [showToasts]="showToast" [title]="toastTitle" [message]="toastMessage"></app-clickatell-toasts>